import { AfterViewInit, ChangeDetectionStrategy, Component } from '@angular/core';

import { isIE } from '@common';

import { HomeBrowserSupportModalService } from './home-browser-support/home-browser-support-modal.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeComponent implements AfterViewInit {
  constructor(private homeBrowserSupportModal: HomeBrowserSupportModalService) {}

  ngAfterViewInit(): void {
    if (isIE()) {
      this.homeBrowserSupportModal.openHomeBrowserSupportDialog().subscribe();
    }
  }
}
